module.exports = __webpack_public_path__ + "img/banner05.9f3cf4f9.png";